import {
  web1,
  web2,
  web3,
  web4,
  health1,
  health2,
  music1,
  music2,
  person1,
  person2,
  person3,
  person4,
} from "./images";

export const course = {
  info: {
    title: "Javascript For Beginners",
    students: "208",
    last_Update: "2021/11/09",
    language: "english",
    stars_average: 4.6,
    reviews: "158",
    creator_name: "john doe",
  },
  details: {
    price_old: "100$",
    price_new: "49$",
    price_discount: "51%",
    course_img: web1,
    features: [
      {
        icon: "fas fa-users",
        title: "Ilmiy konferensiyalar",
      },
      {
        icon: "fas fa-calendar-alt",
        title: "Tadbirlar va anjumanlar",
      },
      {
        icon: "fa fa-comments",
        title: "Muhokama va seminarlarda qatnashish",
      },
      {
        icon: "fa fa-video",
        title: "Onlayn konferensiyalar",
      },
      {
        icon: "fa fa-bookmark",
        title: "Konferensiya materiallari va resurslar",
      },
      {
        icon: "fa fa-certificate",
        title: "Konferensiya ishtirokchilari uchun sertifikatlar",
      },
    ],
  },

  rating: {
    stars: [
      { percent: "60%", star: 5 },
      { percent: "20%", star: 4 },
      { percent: "10%", star: 3 },
      { percent: "7%", star: 2 },
      { percent: "3%", star: 1 },
    ],
    stars_average: 4.6,
    reviews: "158",
  },

  chapters: [
    {
      id: 1,
      title: "Introduction",
      // total_parts: "14",
      // total_time: "1hr 3min",
      parts: [
        { sub_title: "Introduction", time: "08:12" },
        { sub_title: "What is JavaScript?", time: "03:24" },
        { sub_title: "JavaScript in Action!", time: "12:21" },
        { sub_title: "How JavaScript Is Executed", time: "09:33" },
        { sub_title: "Dynamic vs Weakly Typed Languages", time: "10:15" },
        {
          sub_title: "JavaScript Executes In A Hosted Environment",
          time: "15:12",
        },
      ],
    },
    {
      id: 2,
      title: "Basics: Variables, Data Types,...",
      total_parts: "39",
      total_time: "3hr 16min",
      parts: [
        { sub_title: "Introduction", time: "08:12" },
        { sub_title: "What is JavaScript?", time: "03:24" },
        { sub_title: "JavaScript in Action!", time: "12:21" },
        { sub_title: "How JavaScript Is Executed", time: "09:33" },
        { sub_title: "Dynamic vs Weakly Typed Languages", time: "10:15" },
        {
          sub_title: "JavaScript Executes In A Hosted Environment",
          time: "15:12",
        },
      ],
    },
    {
      id: 3,
      title: "Efficient Development ",
      total_parts: "19",
      total_time: "1hr 15min",
      parts: [
        { sub_title: "Introduction", time: "08:12" },
        { sub_title: "What is JavaScript?", time: "03:24" },
        { sub_title: "JavaScript in Action!", time: "12:21" },
        { sub_title: "How JavaScript Is Executed", time: "09:33" },
        { sub_title: "Dynamic vs Weakly Typed Languages", time: "10:15" },
        {
          sub_title: "JavaScript Executes In A Hosted Environment",
          time: "15:12",
        },
      ],
    },
    {
      id: 4,
      title: "Working with Control Structures",
      total_parts: "38",
      total_time: "3hr 52min",
      parts: [
        { sub_title: "Introduction", time: "08:12" },
        { sub_title: "What is JavaScript?", time: "03:24" },
        { sub_title: "JavaScript in Action!", time: "12:21" },
        { sub_title: "How JavaScript Is Executed", time: "09:33" },
        { sub_title: "Dynamic vs Weakly Typed Languages", time: "10:15" },
        {
          sub_title: "JavaScript Executes In A Hosted Environment",
          time: "15:12",
        },
      ],
    },
    {
      id: 5,
      title: "Behind the Scenes of JavaScript",
      total_parts: "12",
      total_time: "1hr 34min",
      parts: [
        { sub_title: "Introduction", time: "08:12" },
        { sub_title: "What is JavaScript?", time: "03:24" },
        { sub_title: "JavaScript in Action!", time: "12:21" },
        { sub_title: "How JavaScript Is Executed", time: "09:33" },
        { sub_title: "Dynamic vs Weakly Typed Languages", time: "10:15" },
        {
          sub_title: "JavaScript Executes In A Hosted Environment",
          time: "15:12",
        },
      ],
    },
  ],

  description: {
    course_desc:
      "JavaScript is THE most important programming language you need to learn as a web developer - and with this course, you make sure that you will not miss a single thing you have to know as a JavaScript developer!This is the most comprehensive and modern course you can find on JavaScript - it's based on all my JavaScript knowledge AND teaching experience. It's both a complete guide, starting with the core basics of the language, as well as an extensive reference of the JavaScript language and environment, ensuring that both newcomers as well as experienced JavaScript developers get a lot out of this course.",
    course_info: {
      question: "Who this course is for",
      answer: [
        "Beginner web development students who have no or only little JavaScript experience",
        "Also developers who know the basics about JavaScript and want to deepen their knowledge",
        "Advanced JavaScript developers who want to learn more about the nitty-gritty details and dive into advanced concepts",
        "Everyone interested in learning JavaScript and all about how it works",
      ],
    },
  },
  coments: [
    {
      user: "David M.",
      img: person1,
      time: "1 year ago",
      star: "5",

      title: "Really useful",
      text: "Beyond very pragmatic explanations about basic and advanced JavaScript concepts, the course is full of best practices to design/build apps in JavaScript without frameworks (huge focus on the DOM). This is not so easy to find as most of the courses focus on vanilla JS to build basic examples or frameworks to build more advanced apps. Really useful!",
    },
    {
      user: "Matsu C",
      img: person2,
      time: "2 days ago",
      star: "4",
      title: "Keep learning",
      text: "Bundling the courses and know how of successful instructors, Academind strives to deliver high quality online educationOnline Education, RealLife Success that's what Academind stands for. Learn topics like web development, data analyses and more in a fun and engaging way.Currently, you can find courses published by Maximilian Schwarzmüller and Manuel Lorenz, more instructors to come!",
    },
    {
      user: "Christopher A.",
      img: person3,
      time: "6 days ago",
      star: "5",
      title: "good course",
      text: "I have taken almost 2 months to complete this course. For the reason I started this course is because I wanna explore deeper in React. Max React Course is extremely amazing as well, and let me got an offer!What I really wanna emphasize it that this JS - Complete Course gives me the Confidence to say Give me network and JS, I can create any software!. Maybe a bit boast, but that is really how I feel whenever I learn from Max.I wanna say thank you Max, even though we never meet in real life, you are really my best mentor in my life time, and I appreciate a lot you spend so many time on create these fabulous courses! Hope that I can create something helpful to people like you do to world, in the future",
    },
    {
      user: "Ncha Takoh E.",
      img: person4,
      time: "just a moment ago",
      star: "4",
      title: "very useful",
      text: "it was nice course at least i got some understanding where i was in doubt, the instructor was good, that is why i was able to buy two of it course again react and nodejs",
    },
  ],

  creator: {
    creator_name: "Muratov Xakim Maxmudovich",
    creator_rating: "texnika fanlari doktori, professor",
    creator_email: "energetika@academy.uz",
    creator_phone: "+998 (71) 283-23-08",
    creator_skill: "web developer",
    creator_img:
      "https://storage.academy.uz/source/1/podvedmstvo/Muratov%20Xakim%20Maxmudovich.jpg",
    creator_desc:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet.Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero. Sed cursus ante dapibus diam. Sed nisi. Nulla quis sem at nibh elementum imperdiet.",
  },
};

export const courses = [
  {
    id: 1,
    title: "Html For Beginners",
    course_img: web1,
    creator: "john smilga",
    creator_img: person1,
    star: 4.8,
    price: "19",
    category: "web",
  },
  {
    id: 2,
    title: "Css For Beginners",
    course_img: web2,
    creator: "john smilga",
    creator_img: person2,
    star: 4,
    price: "10",
    category: "web",
  },
  {
    id: 3,
    title: "Javascript",
    course_img: web3,
    creator: "jessica fleming",
    creator_img: person3,
    star: 3.9,
    price: "21",
    category: "web",
  },
  {
    id: 4,
    title: "Php Advance",
    course_img: web4,
    creator: "wes bos",
    creator_img: person4,
    star: 3.4,
    price: "18",
    category: "web",
  },
  {
    id: 5,
    title: "Weight Loss Course",
    course_img: health1,
    creator: "dr karen e wells",
    creator_img: person2,
    star: 4.1,
    price: "35",
    category: "health",
  },
  {
    id: 6,
    title: "Nutrition",
    course_img: health2,
    creator: "chris worfolk",
    creator_img: person3,
    star: 4.6,
    price: "15",
    category: "health",
  },
  {
    id: 7,
    title: "Become A Singer",
    course_img: music1,
    creator: "laura goellner",
    creator_img: person1,
    star: 3.8,
    price: "105",
    category: "music",
  },
  {
    id: 8,
    title: "Guitar Master",
    course_img: music2,
    creator: "devatma saraswat",
    creator_img: person3,
    star: 3.2,
    price: "99",
    category: "music",
  },
];
//! contact informations
export const contact = {
  tel: "+998911312071",
  days: "Dushanba /Juma",
  time: "9:00-18:00",
  map: {
    name: "Toshkent shahar, Mirzo Ulug'bek, Do'rmon yo'li 40",
    location: "https://yandex.uz/maps/-/CDxBIEOz",
  },
  email: "admin@emi.uz",
  social: [
    { icon: "fab fa-facebook", path: "https://facebook.com" },
    { icon: "fab fa-twitter", path: "https://facebook.com" },
    { icon: "fab fa-instagram", path: "https://facebook.com" },
  ],
  creator: { title: "optimum", path: "#" },
};
//! contact informations
export const navbar = [
  { title: "Home", path: "#", subcategory: [] },
  { title: "User", path: "#", subcategory: [{ title: "Login", path: "#" }] },
];
// functionary data
export const functionary = [
  {
    _id: 1,
    type: "leader",
    name: "Donyor Karimov",
    rank: "t.f.d prof",
    age: "34",
    photo:
      "https://avatars.mds.yandex.net/i?id=6098c9abc55b72fdb48059ff61989aa49f42ba5dd058d8f6-5345654-images-thumbs&n=13",
    position: "Direktor",
    date: "11-06-2023",
    description:
      "Institut rahbari, innovatsion tadqiqotlar bo'yicha yetakchi mutaxassis.",
    email: "donyor.karimov@emi.uz",
    phone: "+998901234567",
    address:
      "Toshkent shahar, Mirzo Ulug'bek tumani, Muxtor-Ashrafiy ko'chasi, 9-A",
    skills: ["Energetika", "Boshqaruv", "Innovatsion texnologiyalar"],
    social: {
      facebook: "https://www.facebook.com/donyor.karimov",
      linkedin: "https://www.linkedin.com/in/donyor-karimov/",
    },
  },
  {
    _id: 2,
    type: "worker",
    name: "Ochilov Laziz",
    rank: "t.f.d prof",
    age: "34",
    photo:
      "https://steamuserimages-a.akamaihd.net/ugc/1863939249779832219/A91CD41CF7B8DF6278A7AA07635DFCF031783735/?imw=512&amp;imh=514&amp;ima=fit&amp;impolicy=Letterbox&amp;imcolor=%23000000&amp;letterbox=true",
    position: "Texnik",
    date: "11-06-2023",
    description: "Texnik yordam, asbob-uskuna va jihozlar uchun javobgar.",
    email: "ochilov.laziz@emi.uz",
    phone: "+998901234568",
    address: "Toshkent shahar, Chilonzor tumani, Parkent ko'chasi, 10-B",
    skills: ["Texnik qo'llab-quvvatlash", "Asbob-uskunalar"],
    social: {
      linkedin: "https://www.linkedin.com/in/laziz-ochilov/",
    },
  },
  {
    _id: 3,
    type: "researcher",
    name: "Shukhrat Abdurahmonov",
    rank: "t.f.d prof",
    age: "39",
    photo:
      "https://steamuserimages-a.akamaihd.net/ugc/1863939249779832219/A91CD41CF7B8DF6278A7AA07635DFCF031783735/?imw=512&amp;imh=514&amp;ima=fit&amp;impolicy=Letterbox&amp;imcolor=%23000000&amp;letterbox=true",
    position: "Tadqiqotchi",
    date: "10-05-2022",
    description: "Iqlimshunoslik bo'yicha tadqiqot olib boradi.",
    email: "shukhrat.abdurahmonov@emi.uz",
    phone: "+998901234569",
    address: "Toshkent shahar, Yunusobod tumani, Azimov ko'chasi, 12",
    skills: ["Iqlimshunoslik", "Energiya samaradorligi"],
    social: {
      facebook: "https://www.facebook.com/shukhrat.abdurahmonov",
    },
  },
];
// functionary data
//! results data

export const researchs = [
  {
    id: 1,
    title: "Yuqori samarali energiya saqlash texnologiyalari",
    type: "Research Project",
    photo:
      "https://avatars.mds.yandex.net/i?id=3dd66c9ddbbc47e59886077830254452b0cbfe00-7758455-images-thumbs&n=13",
    description:
      "Bu tadqiqot loyihasi energiya saqlash tizimlarining samaradorligini oshirishga qaratilgan innovatsion yondashuvlarni ishlab chiqishni maqsad qiladi.",
    startDate: "2023-01-15",
    endDate: "2025-01-15",
    leadResearcher: "Donyor Karimov",
    funding: "50,000,000 UZS",
    status: "Active",
    email: "donyor.karimov@emi.uz",
    phone: "+998901234567",
  },
  {
    id: 2,
    title: "Qayta tiklanadigan energiya manbalarini integratsiyalash",
    type: "Research Project",
    photo:
      "https://avatars.mds.yandex.net/i?id=b6c4197c0001eb7d239521b3aba1894c969457b6-10149683-images-thumbs&n=13",
    description:
      "Bu loyiha qayta tiklanadigan energiya manbalarining tarmoqlarga integratsiyasini o'rganishni maqsad qiladi, shu jumladan quyosh va shamol energiyasi.",
    startDate: "2022-06-01",
    endDate: "2024-06-01",
    leadResearcher: "Alisher Abdullayev",
    funding: "30,000,000 UZS",
    status: "Completed",
    email: "alisher.abdullayev@emi.uz",
    phone: "+998901234568",
  },
  {
    id: 3,
    title: "Intellektual elektr energiya tarmoqlari",
    type: "Project",
    photo:
      "https://avatars.mds.yandex.net/i?id=057982672288d7b5a61107d06a9d8299_l-4818428-images-thumbs&n=13",
    description:
      "Intellektual tarmoqlarni rivojlantirish va ularga asoslangan energiya ta'minot tizimlarini optimallashtirish uchun yangi texnologiyalarni tadqiq qilish.",
    startDate: "2023-03-10",
    endDate: "2026-03-10",
    leadResearcher: "Shavkat Yuldoshev",
    funding: "80,000,000 UZS",
    status: "Active",
    email: "shavkat.yuldoshev@emi.uz",
    phone: "+998901234569",
  },
  {
    id: 4,
    title: "Kuchlanish regulatorlarini optimallashtirish",
    type: "Research Project",
    photo:
      "https://avatars.mds.yandex.net/i?id=23ba4bb085302bca9b9cbaf415fda8634b9d18c3-10331033-images-thumbs&n=13",
    description:
      "Bu loyiha elektr energiyasini ta'minlash tizimlarida kuchlanish regulatorlarining samaradorligini oshirishga qaratilgan.",
    startDate: "2021-11-20",
    endDate: "2023-11-20",
    leadResearcher: "Farukh Karimov",
    funding: "40,000,000 UZS",
    status: "Completed",
    email: "farukh.karimov@emi.uz",
    phone: "+998901234570",
  },
  {
    id: 5,
    title: "Energiya samaradorligi va energiya tejash",
    type: "project",
    photo:
      "https://avatars.mds.yandex.net/i?id=a1633c686274837958aa79ea45467ddb7cb55fed-5250144-images-thumbs&n=13",
    description:
      "Bu tadqiqot energiya samaradorligini oshirish va energiya tejashning yangi usullarini ishlab chiqishga qaratilgan.",
    startDate: "2023-09-05",
    endDate: "2025-09-05",
    leadResearcher: "Ochilov Laziz",
    funding: "60,000,000 UZS",
    status: "Active",
    email: "ochilov.laziz@emi.uz",
    phone: "+998901234571",
  },
  {
    id: 6,
    title: "Yuqori samarali energiya saqlash texnologiyalari",
    type: "Research Project",
    photo:
      "https://avatars.mds.yandex.net/i?id=3dd66c9ddbbc47e59886077830254452b0cbfe00-7758455-images-thumbs&n=13",
    description:
      "Bu tadqiqot loyihasi energiya saqlash tizimlarining samaradorligini oshirishga qaratilgan innovatsion yondashuvlarni ishlab chiqishni maqsad qiladi.",
    startDate: "2023-01-15",
    endDate: "2025-01-15",
    leadResearcher: "Donyor Karimov",
    funding: "50,000,000 UZS",
    status: "Active",
    email: "donyor.karimov@emi.uz",
    phone: "+998901234567",
  },
];
export const partners = [
  {
    id: 1,
    name: "O‘zbekiston Energetika Kompaniyasi",
    logo: "https://avatars.mds.yandex.net/i?id=606e7278d3d60fdcdf6fd11b720ed10217c33d89-5886887-images-thumbs&n=13",
    website: "https://energetika.uz",
    email: "contact@energetika.uz",
  },
  {
    id: 2,
    name: "Toshkent Elektr Stansiyasi",
    logo: "https://avatars.mds.yandex.net/i?id=606e7278d3d60fdcdf6fd11b720ed10217c33d89-5886887-images-thumbs&n=1",
    website: "https://tashkentpower.uz",
    email: "contact@tashkentpower.uz",
  },
  {
    id: 3,
    name: "Qayta Tiklanadigan Energiya Manbalari Assotsiatsiyasi",
    logo: "https://avatars.mds.yandex.net/i?id=3f13c5be24999152f8aa627c3a8fc602-5291412-images-thumbs&n=13",
    website: "https://renewables.uz",
    email: "contact@renewables.uz",
  },
  {
    id: 4,
    name: "Shamol Energiya Xizmatlari",
    logo: "https://avatars.mds.yandex.net/i?id=606e7278d3d60fdcdf6fd11b720ed10217c33d89-5886887-images-thumbs&n=1",
    website: "https://windenergy.uz",
    email: "contact@windenergy.uz",
  },
  {
    id: 5,
    name: "Hidroquch Energiya Kompaniyasi",
    logo: "https://avatars.mds.yandex.net/i?id=3f13c5be24999152f8aa627c3a8fc602-5291412-images-thumbs&n=13",
    website: "https://hydropower.uz",
    email: "contact@hydropower.uz",
  },
  {
    id: 6,
    name: "Yashil Energiya Tashkiloti",
    logo: "https://avatars.mds.yandex.net/i?id=606e7278d3d60fdcdf6fd11b720ed10217c33d89-5886887-images-thumbs&n=1",
    website: "https://greenenergy.uz",
    email: "contact@greenenergy.uz",
  },
  {
    id: 7,
    name: "Samarali Energiya Tizimlari",
    logo: "https://avatars.mds.yandex.net/i?id=3f13c5be24999152f8aa627c3a8fc602-5291412-images-thumbs&n=13",
    website: "https://efficiency.uz",
    email: "contact@efficiency.uz",
  },
  {
    id: 8,
    name: "Qayta Tiklanadigan Energiya Markazi",
    logo: "https://avatars.mds.yandex.net/i?id=3f13c5be24999152f8aa627c3a8fc602-5291412-images-thumbs&n=13",
    website: "https://renewablecenter.uz",
    email: "contact@renewablecenter.uz",
  },
];
export const ielts = [
  {
    _id: 1,
    candidate: "Donyor Karimov",
    overall: "7.5",
    level: "C1",
    certificate:
      "https://image.slidesharecdn.com/ad28dffb-b1e9-4415-9aea-7f550931122e-150927024955-lva1-app6892/85/ielts-certificate-1-320.jpg?cb=1665795706",
    teacher: "Odiljon Farhodov",
    date: "11-06-2023",
  },
  {
    _id: 2,
    candidate: "Jamjid Qayumov",
    overall: "6.5",
    level: "B2",
    certificate:
      "https://image.slidesharecdn.com/ad28dffb-b1e9-4415-9aea-7f550931122e-150927024955-lva1-app6892/85/ielts-certificate-1-320.jpg?cb=1665795706",
    teacher: "Odiljon Farhodov",
    date: "11-06-2023",
  },
  {
    _id: 11,
    candidate: "Donyor Karimov",
    overall: "7.5",
    level: "C1",
    certificate:
      "https://image.slidesharecdn.com/ad28dffb-b1e9-4415-9aea-7f550931122e-150927024955-lva1-app6892/85/ielts-certificate-1-320.jpg?cb=1665795706",
    teacher: "Odiljon Farhodov",
    date: "11-06-2023",
  },
  {
    _id: 21,
    candidate: "Jamjid Qayumov",
    overall: "6.5",
    level: "B2",
    certificate:
      "https://image.slidesharecdn.com/ad28dffb-b1e9-4415-9aea-7f550931122e-150927024955-lva1-app6892/85/ielts-certificate-1-320.jpg?cb=1665795706",
    teacher: "Odiljon Farhodov",
    date: "11-06-2023",
  },
  {
    _id: 12,
    candidate: "Donyor Karimov",
    overall: "7.5",
    level: "C1",
    certificate:
      "https://image.slidesharecdn.com/ad28dffb-b1e9-4415-9aea-7f550931122e-150927024955-lva1-app6892/85/ielts-certificate-1-320.jpg?cb=1665795706",
    teacher: "Odiljon Farhodov",
    date: "11-06-2023",
  },
  {
    _id: 22,
    candidate: "Jamjid Qayumov",
    overall: "6.5",
    level: "B2",
    certificate:
      "https://image.slidesharecdn.com/ad28dffb-b1e9-4415-9aea-7f550931122e-150927024955-lva1-app6892/85/ielts-certificate-1-320.jpg?cb=1665795706",
    teacher: "Odiljon Farhodov",
    date: "11-06-2023",
  },
  {
    _id: 13,
    candidate: "Donyor Karimov",
    overall: "7.5",
    level: "C1",
    certificate:
      "https://image.slidesharecdn.com/ad28dffb-b1e9-4415-9aea-7f550931122e-150927024955-lva1-app6892/85/ielts-certificate-1-320.jpg?cb=1665795706",
    teacher: "Odiljon Farhodov",
    date: "11-06-2023",
  },
  {
    _id: 23,
    candidate: "Jamjid Qayumov",
    overall: "6.5",
    level: "B2",
    certificate:
      "https://image.slidesharecdn.com/ad28dffb-b1e9-4415-9aea-7f550931122e-150927024955-lva1-app6892/85/ielts-certificate-1-320.jpg?cb=1665795706",
    teacher: "Odiljon Farhodov",
    date: "11-06-2021",
  },
];
export const sat = [
  {
    _id: 1,
    candidate: "Xurshid Ahmedov",
    overall: "1370",
    level: "",
    certificate:
      "https://images.squarespace-cdn.com/content/v1/59da575bc027d8973df02f15/1523976869523-1FEPKW8K7SV6YQU5QON6/Screen+Shot+2018-04-17+at+9.47.38+AM.png?format=1000w",
    teacher: "Odil Karimov",
    date: "11-06-2023",
  },
  {
    _id: 2,
    candidate: "Xurshid Ahmedov",
    overall: "1370",
    level: "",
    certificate:
      "https://images.squarespace-cdn.com/content/v1/59da575bc027d8973df02f15/1523976869523-1FEPKW8K7SV6YQU5QON6/Screen+Shot+2018-04-17+at+9.47.38+AM.png?format=1000w",
    teacher: "Odil Karimov",
    date: "11-06-2023",
  },
  {
    _id: 11,
    candidate: "Xurshid Ahmedov",
    overall: "1370",
    level: "",
    certificate:
      "https://images.squarespace-cdn.com/content/v1/59da575bc027d8973df02f15/1523976869523-1FEPKW8K7SV6YQU5QON6/Screen+Shot+2018-04-17+at+9.47.38+AM.png?format=1000w",
    teacher: "Odil Karimov",
    date: "11-06-2023",
  },
  {
    _id: 21,
    candidate: "Xurshid Ahmedov",
    overall: "1370",
    level: "",
    certificate:
      "https://images.squarespace-cdn.com/content/v1/59da575bc027d8973df02f15/1523976869523-1FEPKW8K7SV6YQU5QON6/Screen+Shot+2018-04-17+at+9.47.38+AM.png?format=1000w",
    teacher: "Odil Karimov",
    date: "11-06-2023",
  },
];
export const cefr = [
  {
    _id: 13,
    candidate: "Sarvarbek Yo'ldoshev",
    overall: "59",
    level: "B2",
    certificate:
      "https://www.jomboy.uz/sites/default/files/u33/IMG_20230514_125228_214.jpg",
    teacher: "Dilnoza Latipova",
    date: "11-06-2022",
  },
  {
    _id: 12,
    candidate: "Sarvarbek Yo'ldoshev",
    overall: "59",
    level: "B2",
    certificate:
      "https://www.jomboy.uz/sites/default/files/u33/IMG_20230514_125228_214.jpg",
    teacher: "Dilnoza Latipova",
    date: "11-06-2022",
  },
  {
    _id: 11,
    candidate: "Sarvarbek Yo'ldoshev",
    overall: "59",
    level: "B2",
    certificate:
      "https://www.jomboy.uz/sites/default/files/u33/IMG_20230514_125228_214.jpg",
    teacher: "Dilnoza Latipova",
    date: "11-06-2022",
  },
  {
    _id: 131,
    candidate: "Sarvarbek Yo'ldoshev",
    overall: "59",
    level: "B2",
    certificate:
      "https://www.jomboy.uz/sites/default/files/u33/IMG_20230514_125228_214.jpg",
    teacher: "Dilnoza Latipova",
    date: "11-06-2022",
  },
  {
    _id: 121,
    candidate: "Sarvarbek Yo'ldoshev",
    overall: "59",
    level: "B2",
    certificate:
      "https://www.jomboy.uz/sites/default/files/u33/IMG_20230514_125228_214.jpg",
    teacher: "Dilnoza Latipova",
    date: "11-06-2022",
  },
  {
    _id: 111,
    candidate: "Sarvarbek Yo'ldoshev",
    overall: "59",
    level: "B2",
    certificate:
      "https://www.jomboy.uz/sites/default/files/u33/IMG_20230514_125228_214.jpg",
    teacher: "Dilnoza Latipova",
    date: "11-06-2022",
  },
];